/** Wraps Phaser's arcade physics body and exposes a simple velocity interface. */
import Phaser from 'phaser';
import { Component } from './Component';

/** Attaches an Arcade physics body to a sprite and exposes velocity control for movement systems. */
export class PhysicsComponent implements Component {
  body: Phaser.Physics.Arcade.Body;

  constructor(scene: Phaser.Scene, sprite: Phaser.GameObjects.GameObject) {
    scene.physics.add.existing(sprite);
    this.body = sprite.body as Phaser.Physics.Arcade.Body;
    this.body.setCollideWorldBounds(true);
  }

  /** Set the physics body velocity in pixels per second. */
  setVelocity(x: number, y: number): void {
    this.body.setVelocity(x, y);
  }

  update(_delta: number): void {
    // Physics is handled by Phaser's arcade system
  }

  destroy(): void {
    // Body is destroyed with the sprite
  }
}
